const STORAGE_KEY = "e4e_platform_access_block";

export function storePlatformAccessBlock(payload) {
  if (!payload) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_err) {
    // ignore storage errors
  }
}

export function readStoredPlatformAccessBlock() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_err) {
    return null;
  }
}

export function clearStoredPlatformAccessBlock() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (_err) {
    // ignore storage errors
  }
}
